import { FormattedMessage, useIntl } from 'react-intl';
import { PREPARATION_STAGES, type PreparationStage } from '../../types';
import StageIcon from './StageIcon';

interface Props {
  onChoose: (stage: PreparationStage) => void;
}

export default function StagePicker({ onChoose }: Props) {
  const intl = useIntl();

  return (
    <div>
      <p className="text-sm text-slate-500">
        <FormattedMessage id="preparation.picker.hint" />
      </p>

      <ol className="mt-5 space-y-1">
        {PREPARATION_STAGES.map((stage, index) => {
          const answer = intl.formatMessage({ id: `preparation.picker.answer.${stage}` });

          return (
            <li key={stage} className="flex flex-col items-stretch">
              <button
                type="button"
                onClick={() => onChoose(stage)}
                aria-label={answer}
                className={optionClasses()}
              >
                <span className={stageMarkerClasses()}>
                  <StageIcon stage={stage} />
                </span>
                <span className="min-w-0 flex-1 text-base font-medium leading-6 text-slate-900">{answer}</span>
                <span aria-hidden="true" className="text-xl text-slate-300 transition-transform group-hover:translate-x-0.5">›</span>
              </button>
              {index < PREPARATION_STAGES.length - 1 && (
                <span aria-hidden="true" className="ml-5 h-1 w-px bg-slate-200" />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

function optionClasses(): string {
  const base =
    'group flex w-full items-center gap-2 rounded-2xl border px-4 py-3 text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300';

  return `${base} border-slate-200 bg-white hover:border-brand-300 hover:bg-brand-50/40`;
}

function stageMarkerClasses(): string {
  return 'flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500';
}
